import type { CreateCourseDraft201PriceCurrency } from './createCourseDraft201PriceCurrency';

/**
 * 코스 가격 정보
 * @nullable
 */
export type CreateCourseDraft201Price = {
  /**
   * 가격 (0은 무료)
   * @minimum 0
   */
  amount: number;
  /** 통화 코드 */
  currency: CreateCourseDraft201PriceCurrency;
} | null;
